const { actionUtils, config } = require('@sstdev/lib_metadata-config');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP = 'A button to put on a form.';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    // Set button style
    let styleDropDown = new Blockly.FieldDropdown(config.buttonStyles);
    styleDropDown.setValue('IconAction');
    line1OfInputs
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput('more-horizontal'), 'iconName')
        .appendField('  Form Action:')
        .appendField(new Blockly.FieldDropdown(config.formActions), 'formAction')
        .appendField('  (optional except for "Create" action) Subtype:')
        .appendField(new Blockly.FieldTextInput(), 'subtype')
        .appendField('  Button Style (old):')
        .appendField(styleDropDown, 'buttonStyle')
        .appendField('  Button Size (new):')
        .appendField(new Blockly.FieldDropdown(config.componentSize), 'size')
        .appendField('  Button Variant (new):')
        .appendField(new Blockly.FieldDropdown(config.buttonVariants), 'variant')
        .appendField('  Show icon in header:')
        .appendField(new Blockly.FieldCheckbox(false), 'displayInHeader');

    blocklyBlock.appendStatementInput('preLogic').setCheck('workflowLogic').appendField('Do Before:');
    setValidation(blocklyBlock);
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['title', 'formAction', 'iconName', 'buttonStyle', 'size', 'variant', 'subtype']);
    if (blocklyBlock.getFieldValue('displayInHeader') === 'TRUE') code.displayInHeader = true;
    const stringLogic = Blockly.JavaScript.statementToCode(blocklyBlock, 'preLogic');
    if (stringLogic) {
        code.preLogic = JSON.parse(`[${stringLogic}]`);
    }
    return code;
}

function setValidation(blocklyBlock) {
    // Validate the entire block whenever any part of it changes,
    // and display a warning if the block cannot be made valid.
    blocklyBlock.setOnChange(function (event) {
        const initialGroup = Blockly.Events.getGroup();
        // Keep the validity change in the same undo group as the editor change.
        Blockly.Events.setGroup(event.group);
        try {
            validateBlock(blocklyBlock);
        } finally {
            Blockly.Events.setGroup(initialGroup);
        }
    });
}

// Headless compilation suppresses queued editor events. Use the same validity
// rule synchronously after loading, before generation or source persistence.
function validateWorkspace(workspace) {
    workspace.getBlocksByType('formButton_FormButton', false).forEach(validateBlock);
}

function validateBlock(block) {
    const valid = block.getFieldValue('formAction') !== 'create' || !!block.getFieldValue('subtype');
    block.setWarningText(valid ? null : 'A subtype is required for the "create" form action.');
    // Flyout entries must remain draggable even when not configured yet.
    if (!block.isInFlyout) block.setEnabled(valid);
}

/** Builds schema for the FormButton and returns [subDataDictionary, partialTypeDefinition]. */
function asDataDictionary(hNode, context = {}, parentAccessRestrictions) {
    const { formAction } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(hNode, context, parentAccessRestrictions);
    if (accessRestrictions.hidden) return [{}, {}];

    // FormButton operates within a form context and triggers form actions (save, cancel, create, etc.)
    // It doesn't define namespace/relation itself - it uses the parent form's context
    // Therefore it returns empty subDataDictionary and partialTypeDefinition

    // The formAction value affects what operations the parent form should support
    // but the actual schema contribution is handled by the form elements, not the button
    return [{}, {}];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary, validateWorkspace };
